import React from "react";
import { modalGateActive } from "./modalGate";

// Subscribes to window keydown events for a single key (KeyboardEvent.key
// name, e.g. "Escape") and runs `handler`. The handler is captured fresh
// on every render via a ref, so callers don't need to memoize it.
//
// While a modal dialog is up (see modalGate.js) handlers are inert unless
// the caller passes { whenModal: true } — only the dialog's own keys
// should work under a modal.
//
// { caseless: true } matches letter keys regardless of Shift/CapsLock,
// since KeyboardEvent.key reports "Z" with either held.
export default function useKey(
  key,
  handler,
  { whenModal = false, caseless = false } = {},
) {
  const handlerRef = React.useRef(handler);
  handlerRef.current = handler;

  React.useEffect(() => {
    const matches = caseless
      ? (k) => k.toLowerCase() === key.toLowerCase()
      : (k) => k === key;
    const onKey = (e) => {
      if (modalGateActive() && !whenModal) return;
      if (matches(e.key)) handlerRef.current(e);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [key, whenModal, caseless]);
}
